import AuthForm from '../components/auth/AuthForm';

const LoginPage = () => {
	return <AuthForm />;
};

export default LoginPage;
